import { themes } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function ThemeSection() {
  return (
    <section id="themes" className="w-full bg-background-100 py-14 md:py-20 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          align="center"
          kicker="主题分类"
          title="主题图集 · 按类来逛"
          desc="红毯、发布会、综艺、街拍与音乐现场，每一类都有完整的高清集合。选一个主题，沉浸式看完全场直出。"
        />

        <div className="mt-10 grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {themes.map((t) => (
            <a
              key={t.id}
              href="#gallery"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("gallery")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="group relative rounded-lg overflow-hidden bg-background-200 block"
            >
              <div className="relative aspect-[4/5] w-full overflow-hidden">
                <img
                  src={t.img}
                  alt={`${t.name}${t.en}主题现场高清图集`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/15 to-transparent"></div>

                <div className="absolute top-3 right-3 px-2.5 py-1 rounded text-[11px] font-semibold text-background-50 bg-accent-500 whitespace-nowrap">
                  {t.count}
                </div>

                <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                  <p className="text-[10px] md:text-xs tracking-[0.2em] text-accent-300 font-medium uppercase">
                    {t.en}
                  </p>
                  <h3 className="mt-1 text-lg md:text-xl font-heading font-bold text-background-50">{t.name}</h3>
                  <p className="mt-1 text-xs text-background-100/85 leading-relaxed">{t.desc}</p>
                  <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-background-50 opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition">
                    进入浏览 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}